/**
 * @param {string | undefined | null} input - DD-MM-YYYY HH:MM:SS
 * @returns {number | null}
 */
export function parseCountdownDate(input) {
  if (!input) return null;

  const parts = input.match(/(\d+)/g);
  if (!parts || parts.length < 3) return null;

  return new Date(
    Number(parts[2]),
    Number(parts[1]) - 1,
    Number(parts[0]),
    Number(parts[3] || 0),
    Number(parts[4] || 0),
    Number(parts[5] || 0),
  ).getTime();
}

/**
 * @param {number} timeLeft - milliseconds remaining
 * @returns {string}
 */
export function formatCountdown(timeLeft) {
  const sanitized = Math.max(0, timeLeft);
  const days = Math.floor(sanitized / (1000 * 60 * 60 * 24));
  const hours = Math.floor(
    (sanitized % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60),
  );
  const minutes = Math.floor((sanitized % (1000 * 60 * 60)) / (1000 * 60));
  const seconds = Math.floor((sanitized % (1000 * 60)) / 1000);

  return `${days}d : ${hours}h : ${minutes}m : ${seconds}s`;
}

/**
 * @param {number} endDate - timestamp
 * @param {(timeLeft: number) => void} onTick
 * @param {() => void} [onEnd]
 * @returns {() => void}
 */
export function startCountdown(endDate, onTick, onEnd) {
  const tick = () => {
    const timeLeft = endDate - Date.now();

    if (timeLeft <= 0) {
      onEnd?.();
      return false;
    }

    onTick(timeLeft);
    return true;
  };

  if (!tick()) {
    return () => {};
  }

  const intervalId = setInterval(() => {
    if (!tick()) {
      clearInterval(intervalId);
    }
  }, 1000);

  return () => clearInterval(intervalId);
}
